// import { AddCustomerInterface } from "Model/Customer.model";

import axios from "axios";

const BASE_URL = "http://216.38.6.193:3001";




export const customers = async () => {
  try {
    // Simulate fetching data from an API endpoint
    const response = await axios.get(BASE_URL + "/customers");
    // Assuming response.data contains the fetched data from the API

    const sampleData = [
      { id: 1, firstName: "Customer 1", lastName: "cust1" },
      { id: 2, firstName: "Customer 2", lastName: "cust2" },
      { id: 3, firstName: "Customer 3", lastName: "cust3" },
      // Add more dummy data as needed
    ];

    return sampleData;
  } catch (error) {
    console.error("Error fetching customers:", error);
    throw error;
  }
};

export class Customer {
  private static _instance: Customer;

  private constructor() {}

  public static get instance() {
    return this._instance || (this._instance = new this());
  }

  async addCustomer(body: any) {
    const response = await axios.post(
      `${BASE_URL}/api/quickBooks/createNewCustomer`,
      body
    );

    return response;
  }

  async listCustomers(payload: {
    access_token: string;
    offset: number;
    tab: "all" | "new";
  }) {
    const response = await axios.post(
      `${BASE_URL}/api/quickBooks/getAllCustomers`,
      payload
    );

    return response;
  }

  async getAccessToken() {
    const response = await axios.get(`${BASE_URL}/api/quickBooks/accessToken`);
    return response;
  }

  async editCustomer(body: any) {
    const response = await axios.post(
      `${BASE_URL}/api/quickBooks/editCustomer`,
      body
    );

    return response;
  }

  async deleteCustomer(payload: any) {
    const response = await axios.post(
      `${BASE_URL}/api/quickBooks/deleteCustomer`,
      payload
    );

    return response;
  }
  

  async getAllCustomersCount(access_token: string) {
    const payload = { access_token };
    const response = await axios.post(
      `${BASE_URL}/api/quickBooks/getAllCustomersCount`,
      payload
    );

    return response;
  }

  async searchCustomer(payload:any) {
    const response = await axios.post(
      `${BASE_URL}/api/quickBooks/searchCustomers`,
      payload
    );
    return response;
  }

  async updateInvoiceStatus(payload:any) {
    const response = await axios.put(
      `${BASE_URL}/api/quickBooks/updateInvoiceStatus`,
      payload
    );
    return response;
  }
  
}
